module.exports = __webpack_public_path__ + "img/9788949192284.db0a4357.jpg";